import React, { useContext } from 'react';
import styles from './WorkspacesAgencyReports.module.scss';
import { useParams } from 'react-router-dom';
import { AppOptionsContext } from 'ui-smartforce-settings';

export const WorkspacesAgencyReports = (): React.ReactElement<{}> => {
  const { workspaces } = useContext(AppOptionsContext);
  const { workspaceId } = useParams<{ workspaceId: string }>();

  const workspace = workspaces.find((w) => w.id === workspaceId);

  return (
    <div className={styles.workspacesAgencyReports}>
      <h1>{workspace?.name}</h1>
    </div>
  );
};
